<!DOCTYPE html>
<html lang="es">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Dialog Form Permiso</title>
</head>
<body>

<app-button-close-dialog></app-button-close-dialog>
<h2 mat-dialog-title>Acción realizada :: <strong>{{ data.accion == accionesDialog.Agregar ? 'Crear' : data.accion ==
    accionesDialog.Eliminar ? 'Eliminar': data.accion == accionesDialog.Ver
    ? 'Ver' : 'Modificar' }} Permiso</strong></h2>

<!-- Spinners para diferentes operaciones -->
<ngx-spinner [zIndex]="100" name="spCrearPermiso" bdColor="rgba(255,255,255,0.8)" size="default"
  color=" var(--primary-color)" type="ball-atom" [fullScreen]="false">
</ngx-spinner>

<ngx-spinner [zIndex]="100" name="spModificarPermiso" bdColor="rgba(255,255,255,0.8)" size="default"
  color=" var(--primary-color)" type="ball-atom" [fullScreen]="false">
</ngx-spinner>

<ngx-spinner [zIndex]="100" name="spEliminarPermiso" bdColor="rgba(255,255,255,0.8)" size="default"
  color=" var(--primary-color)" type="ball-atom" [fullScreen]="false">
</ngx-spinner>

<mat-dialog-content cdkTrapFocus [cdkTrapFocusAutoCapture]="true" *ngIf="data.accion != accionesDialog.Ver">

  <form [formGroup]="form">
    <ng-container *ngIf="data.accion == accionesDialog.Eliminar; else formTemplate">
      ¿Está seguro que desea eliminar el permiso <b>{{data.descripcion}}</b>?
    </ng-container>

    <ng-template #formTemplate>
      <div class="row">
        <div class="col-sm-12 col-md-6 col-lg-6">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Descripción</mat-label>
            <input placeholder="Descripción del permiso" type="text" formControlName="Descripcion" matInput />
            <mat-error *ngIf="f.Descripcion.errors?.['required']">Este campo es <strong>requerido</strong>.</mat-error>
          </mat-form-field>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-6">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Token</mat-label>
            <input placeholder="Token de identificación" type="text" formControlName="Token" matInput />
            <mat-error *ngIf="f.Token.errors?.['required']">Este campo es <strong>requerido</strong>.</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 col-md-6 col-lg-6">
          <mat-form-field appearance="outline" class="w-100">
            <ngx-spinner [zIndex]="-1" name="spBusquedaRoles" bdColor="rgba(255,255,255,0.8)" size="small"
              color=" var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
            <mat-label>Rol</mat-label>
            <mat-select placeholder="Seleccione un rol" formControlName="Rol">
              <mat-option [value]="rol.id" *ngFor="let rol of roles; let i = index; trackBy: trackByItems">
                {{ rol.descripcion }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="f.Rol.errors?.['required']">Este campo es <strong>requerido</strong>.</mat-error>
          </mat-form-field>
        </div>

        <div class="col-sm-12 col-md-6 col-lg-6">
          <mat-form-field appearance="outline" class="w-100">
            <ngx-spinner [zIndex]="-1" name="spBusquedaCasosUso" bdColor="rgba(255,255,255,0.8)" size="small"
              color=" var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
            <mat-label>Caso de Uso</mat-label>
            <mat-select placeholder="Seleccione un caso de uso" formControlName="CasoUso">
              <mat-option [value]="casoUso.id" *ngFor="let casoUso of casosUso; let i = index; trackBy: trackByItems">
                {{ casoUso.descripcion }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="f.CasoUso.errors?.['required']">Este campo es <strong>requerido</strong>.</mat-error>
          </mat-form-field>
        </div>
      </div>
    </ng-template>
  </form>

</mat-dialog-content>

<mat-dialog-content cdkTrapFocus [cdkTrapFocusAutoCapture]="true" *ngIf="data.accion == accionesDialog.Ver">

  <div *ngIf="data">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <mat-card appearance="outlined">
          <mat-card-header>
            <mat-card-title>Información del Permiso</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="property-row">
              <span class="property-name">Descripción:</span>
              <span class="property-value">{{ data.descripcion | titlecase }}</span>
            </div>
            <div class="property-row">
              <span class="property-name">Token:</span>
              <span class="property-value">{{ data.token }}</span>
            </div>
            <div class="property-row">
              <span class="property-name">Caso de Uso:</span>
              <span class="property-value">{{ data.casoUso | titlecase }}</span>
            </div>
            <div class="property-row">
              <span class="property-name">Rol:</span>
              <span class="property-value">{{ data.rol | titlecase }}</span>
            </div>
          </mat-card-content>
        </mat-card>
      </div>

      <div class="col-sm-12 col-md-6">
        <mat-card appearance="outlined">
          <mat-card-header>
            <mat-card-title>Información de Auditoría</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="property-row">
              <span class="property-name">Fecha de Alta:</span>
              <span class="property-value">{{ data.fechaAlta | date:'dd/MM/yyyy HH:mm' }}</span>
            </div>
            <div class="property-row">
              <span class="property-name">Fecha de Baja:</span>
              <span class="property-value">{{ data.fechaBaja | date:'dd/MM/yyyy HH:mm' || 'N/A' }}</span>
            </div>
            <div class="property-row">
              <span class="property-name">Última Modificación:</span>
              <span class="property-value">{{ data.fechaModificacion | date:'dd/MM/yyyy HH:mm' }}</span>
            </div>
            <div class="property-row">
              <span class="property-name">Creado por:</span>
              <span class="property-value">{{ data.creadoPor?.descripcion || 'Sistema' }}</span>
            </div>
            <div class="property-row">
              <span class="property-name">Modificado por:</span>
              <span class="property-value">{{ data.modificadoPor?.descripcion || 'N/A' }}</span>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <app-button-cancel-dialog></app-button-cancel-dialog>

  <app-button-add *ngIf="data.accion == accionesDialog.Agregar"
    [disabled]="!form.valid"
    (click)="agregar()">
  </app-button-add>

  <app-button-save *ngIf="data.accion == accionesDialog.Modificar"
    [disabled]="!form.valid"
    [isDialogClose]="true"
    (saveClicked)="modificar()"
    (cancelClicked)="closeDialog()">
  </app-button-save>

  <app-button-delete *ngIf="data.accion == accionesDialog.Eliminar"
    (click)="eliminar()"
    (cancelClicked)="closeDialog()"
    [isDialogClose]="true">
  </app-button-delete>
</mat-dialog-actions>

</body>
</html>
